module.exports = __webpack_public_path__ + "static/media/collapse-down.08b5d79a.svg";